import { Component, EventEmitter, Input, Output } from '@angular/core';

/** Shared search input: <payarc-search [(value)]="term" placeholder="Search customers"></payarc-search> */
@Component({
  selector: 'payarc-search',
  template: `
    <div class="pa-search">
      <svg class="pa-search__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true" focusable="false">
        <circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/>
      </svg>
      <input
        class="pa-input pa-search__input"
        type="text"
        [placeholder]="placeholder"
        [attr.aria-label]="placeholder"
        [value]="value"
        (input)="onInput($event)"
      />
      <button
        type="button"
        class="pa-search__clear"
        *ngIf="value"
        aria-label="Clear search"
        (click)="clear()"
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true" focusable="false">
          <path d="M18 6L6 18M6 6l12 12"/>
        </svg>
      </button>
    </div>`,
  styleUrls: ['./payarc-search.component.css'],
  standalone: false
})
export class PayarcSearchComponent {
  @Input() placeholder = 'Search';
  @Input() value = '';
  @Output() valueChange = new EventEmitter<string>();

  onInput(e: Event) {
    this.value = (e.target as HTMLInputElement).value;
    this.valueChange.emit(this.value);
  }

  clear() {
    this.value = '';
    this.valueChange.emit('');
  }
}
